// extracted by mini-css-extract-plugin
export default {"ContentDiv":"MosaicPage_ContentDiv__zAdim"};